import { inject, Injectable } from '@angular/core';
import { IBizEntity } from '@optima-stride-ai/core';
import { launchDeleteDialog, OptimaDefaultModalService, BizEntityStateStoreService } from '@optima-stride-ai/optima-app-framework';
import { GlobalStateService } from '../../../service/global.service';

/**
 * Service for handling business entity deletion with confirmation dialog.
 * Uses the framework's launchDeleteDialog component.
 */
@Injectable({
  providedIn: 'root'
})
export class EntityDeleteService {
  private readonly modalService = inject(OptimaDefaultModalService);
  private readonly bizEntityStateStoreService = inject(BizEntityStateStoreService);
  private readonly globalStateService = inject(GlobalStateService);

  /**
   * Launches a delete confirmation dialog for a business entity.
   * 
   * @param entity - The business entity to delete
   */
  launchDeleteDialog(entity: IBizEntity): void {
    if (!entity || !entity.id) {
      console.error('No valid entity to delete');
      return;
    }

    launchDeleteDialog(
      entity,
      this.modalService,
      async () => {
        const result = await this.bizEntityStateStoreService.delete([String(entity.id)]);
        if (result) {
          this.globalStateService.setBizEntityDeleted(true, entity);
        }
        return result;
      }
    );
  }
}
